import React from 'react';
import {View} from 'MWC';
import tpl from '../templates/zed';
import widgetsHelper from 'utils/getWidget.helper';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: tpl,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    template = tpl;

    constructor(props) {
        super(props);

        // Определяем начальный режим на основе URL параметров
        const urlParams = new URLSearchParams(location.search);
        const anchorParam = urlParams.has('transfers')
            ? 'transfers'
            : urlParams.has('currency_exchange')
            ? 'currency_exchange'
            : urlParams.has('templates-doc')
            ? 'docs'
            : urlParams.has('swift')
            ? 'transfers'
            : urlParams.has('payoneer')
            ? 'transfers'
            : urlParams.has('sepa')
            ? 'transfers'
            : 'info';

        const transfersSubMode = urlParams.has('swift')
            ? 'swift'
            : urlParams.has('payoneer')
            ? 'payoneer'
            : urlParams.has('sepa')
            ? 'sepa'
            : 'swift';

        this.state = {
            ui: this.uiStates.INITIAL,
            showModal: false,
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: [],
            where_by_2: ['path'],
            search_by_2: ['/business/ved-contract/usefull-1'],
            widgets_2: [],
            where_by_3: ['path'],
            search_by_3: ['/business/ved-contract/usefull-2'],
            widgets_3: [],
            mode: anchorParam,
            transfersSubMode: transfersSubMode,
            modes: [
                {
                    mode: 'info',
                    title: 'BUSINESS_VED_BLOCK_NAV_TITLE_1'
                },
                {
                    mode: 'transfers',
                    title: 'BUSINESS_VED_BLOCK_NAV_TITLE_3'
                },
                {
                    mode: 'currency_exchange',
                    title: 'BUSINESS_VED_BLOCK_NAV_TITLE_4'
                },
                {
                    mode: 'docs',
                    title: 'BUSINESS_VED_BLOCK_NAV_TITLE_2'
                }
            ]
        };
        this.toggleMode = this.toggleMode.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.toggleTransfersSubMode = this.toggleTransfersSubMode.bind(this);
        this.widgetsHelper = widgetsHelper;
        return this;
    }
    toggleModal() {
        this.setState({showModal: !this.state.showModal});
    }

    toggleMode = mode => {
        this.setState({mode: mode});
    };

    toggleTransfersSubMode = mode => {
        this.setState({transfersSubMode: mode});
    };

    componentDidMount() {
        this.widgetsHelper.getWidgets.call(this);
        this.widgetsHelper.getWidgets_2.call(this);
        this.widgetsHelper.getWidgets_3.call(this);
        // Скроллим к началу таба после загрузки, если есть якорный параметр
        const urlParams = new URLSearchParams(location.search);
        const hasAnchor =
            urlParams.has('transfers') ||
            urlParams.has('currency_exchange') ||
            urlParams.has('templates-doc') ||
            urlParams.has('swift') ||
            urlParams.has('payoneer') ||
            urlParams.has('sepa');
        if (hasAnchor) {
            setTimeout(() => {
                const wrapper = document.querySelector('.tab-active');
                if (wrapper) {
                    wrapper.scrollIntoView({behavior: 'smooth', block: 'start'});
                }
            }, 1000);
        }
    }
}
